import React, { useState, useEffect, useCallback } from "react";
import editIcon from "../../../../assets/images/budget/dropdown.png";
import downloadIcon from "../../../../assets/images/budget/download.png";
import filterIcon from "../../../../assets/images/budget/filter.png";
import fileColumn from "../../../../assets/images/budget/fileColumn.png";
import Tab, { TabItem } from "../SettingTabs/Tabs";
import { debounce } from "lodash";
import { BudgetReport } from "../BudgetReport";
import "./AddTransaction.css";
import { AllAccount } from "./AccountTypes/AllAccount";
import { CheckingSaving } from "./AccountTypes/CheckingSaving";
import { Investment } from "./AccountTypes/Investment";
import { CreditCard } from "./AccountTypes/CreditCard";
import { LoanAccount } from "./AccountTypes/LoanAccount";
import { UnCategorized } from "./AccountTypes/UnCategorized";
import ROUTES from "../../../../config/routes";
import {
  Modal,
  Select,
  Menu,
  Dropdown,
  DatePicker,
  Icon,
  TreeSelect,
} from "antd";
import { TransactionModal } from "../Modals/TransactionModal";
import DEATH_API from "../../../../apis/death.api";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import moment from "moment";
import Loader from "../../../../components/styled-components/loader/loader";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import { useHistory, useLocation } from "react-router-dom";
import { EditMultipleTransaction } from "../Modals/EditMultipleTransaction";
import axios from "axios";
import { CashTab } from "./AccountTypes/Cash";
import BUDGET_API from "../../../../apis/budget.api";
const { TreeNode } = TreeSelect;
const { Option } = Select;

export const AddTransaction = () => {
  const activeTab = useSelector(
    (state) => state.rootReducer.loginUser.activeBudgetTab
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    console.log(index);
    setSelectedIndex(index);
    setSelectedAccountName(null);
    // setSelectedRowKeys([]);
  };
  const history = useHistory();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [modalTitle, setModalTitle] = useState("Add Transaction");
  const [categories, setCategories] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [searchTransactions, setSearchTransactions] = useState(null);
  const [clientBanks, setClientBanks] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [transactionHistory, setTransactionHistory] = useState(null);
  const [categoryModal, setCategoryModal] = useState(false);
  const [updateState, setUpdateState] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [banksCredit, setBanksCredit] = useState(null);
  const [selectedAccountName, setSelectedAccountName] = useState(null);
  const financialAccess =
    localStorage.getItem("financialAccess") != "undefined" &&
    JSON.parse(localStorage.getItem("financialAccess") || null);
  const handleCancelCategory = () => {
    setCategoryModal(false);
    setFormData(null);
  };

  const handleSaveCategory = async () => {
    console.log(formData);
    setCategoryModal(false);
    let payload = {};
    if (formData && formData.categoryName) {
      payload = {
        ...formData,
      };
    } else {
      payload = {
        categoryName: formData.subCategoryName,
      };
    }
    try {
      setLoading(true);
      let data = await DEATH_API.createCategory(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        await getCategories();
      }
      if (data && data.status === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setFormData(null);
  };
  const handleFilterChnage = (name, value) => {
    if (name === "category") {
      console.log("value", value);
      if (value && value.includes("-")) {
        const [subcategoryName, categoryName] = value
          .split("-")
          .map((item) => item.trim());
        console.log("Subcategory Name:", subcategoryName);
        console.log("Category Name:", categoryName);

        // Find category and subcategory IDs
        let categoryId = null;
        let subcategoryId = null;
        categories &&
          categories.forEach((category) => {
            if (category.categoryName === categoryName) {
              categoryId = category.id;
              const subcategory =
                category.subCategories &&
                category.subCategories.find(
                  (sub) => sub.name === subcategoryName
                );
              if (subcategory) {
                subcategoryId = subcategory.id;
              }
            }
          });

        console.log("Category ID:", categoryId);
        console.log("Subcategory ID:", subcategoryId);
        setFilterData({
          ...filterData,
          // ["categoryName"]: categoryName,
          ["category"]: subcategoryName,
          // ["categoryFromPlaid"]: categoryName,
          // ["categoryId"]: categoryId,
          ["subCategoryId"]: subcategoryId,
          ["subCategoryName"]: subcategoryName,
        });
      } else {
        let categoryId = null;
        categoryId =
          categories &&
          categories.find((item) => item.categoryName === value).id;
        setFilterData({
          ...filterData,
          ["categoryName"]: value,
          ["category"]: value,
          ["categoryId"]: categoryId,
          // ["subCategoryId"]: null,
          // ["subCategory"]: null,
          // ["categoryFromPlaid"]: value,
        });
      }
    } else {
      setFilterData({
        ...filterData,
        [name]: value,
      });
    }
  };
  const handleCancelfilter = () => {
    setDropdown(false);
    setFilterData(null);
  };
  // const buildQueryParams=(filterData) =>{
  //   const params = new URLSearchParams();
  //   Object.entries(filterData).forEach(([key, value]) => {
  //     if (key === "categoryName" || key === "category") return; // Skip categoryName
  //     if (key === "startDate" || key === "endDate") {
  //       value = moment(value).format("YYYY-MM-DD"); // Format dates
  //     }
  //     if (value !== undefined && value !== null && value !== "") {
  //       params.append(key, value);
  //     }
  //   });
  //   return params.toString();
  // }
  const buildQueryParams = (filterData) => {
    const params = new URLSearchParams();
    const currentDate = moment(); // Current date for reference

    let { startDate, endDate } = filterData;

    // Handle missing dates
    if (!startDate && endDate) {
      startDate = moment(endDate).subtract(2, "years").format("YYYY-MM-DD");
    } else if (startDate && !endDate) {
      endDate = moment(startDate).add(2, "years").format("YYYY-MM-DD");
    }

    // Default both dates if missing
    if (!startDate) {
      startDate = currentDate.subtract(2, "years").format("YYYY-MM-DD");
    }
    if (!endDate) {
      endDate = currentDate.add(2, "years").format("YYYY-MM-DD");
    }

    // Append dates and other parameters
    Object.entries({ ...filterData, startDate, endDate }).forEach(
      ([key, value]) => {
        if (key === "categoryName" || key === "category") return; // Skip categoryName
        if (key === "startDate" || key === "endDate") {
          value = moment(value).format("YYYY-MM-DD"); // Format dates
        }
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, value);
        }
      }
    );

    return params.toString();
  };

  const handleApplyFilter = async (filter) => {
    console.log("Filter Data before filtering Transaction:", filter);
    setDropdown(false);
    let categoryId = null;
    console.log("payload filter", filter, buildQueryParams(filter));
    if (filter && Object.keys(filter).length > 0) {
      try {
        let payload = filter;
        console.log("payload", payload, filter);
        setLoading(true);
        const queryParam = buildQueryParams(filter);
        const paginatedQueryParamSend = `${queryParam}&page=1`;
        let initialResponse = await BUDGET_API.fetchFilterTransaction(
          paginatedQueryParamSend
        );

        if (
          !initialResponse ||
          initialResponse.status !== 200 ||
          !initialResponse.data
        ) {
          swal("Error", "Failed to fetch data", "error");
          return;
        }

        const totalPages = initialResponse.data.totalPages;
        let allTransactions = initialResponse.data.transactions || [];

        // Prepare promises for remaining pages
        const pageRequests = [];

        for (let page = 2; page <= totalPages; page++) {
          const paginatedQueryParam = `${queryParam}&page=${page}`;
          pageRequests.push(
            BUDGET_API.fetchFilterTransaction(paginatedQueryParam)
          );
        }

        try {
          // Fetch all pages in parallel
          const responses = await Promise.all(pageRequests);

          // Combine results
          responses.forEach((response) => {
            if (
              response &&
              response.status === 200 &&
              response.data.transactions
            ) {
              allTransactions = allTransactions.concat(
                response.data.transactions
              );
            }
          });

          // Process data
          const allAccount = allTransactions;
          // const allAccount = allTransactions.map((item) => {
          //   if (item.amount && item.typeOfTransaction === null) {
          //     item.amount = -1 * item.amount;
          //   }
          //   return item;
          // });

          const checkingSavingData = allAccount.filter(
            (item) =>
              (item.accountType === "checking" ||
                item.accountType === "savings") &&
              item.categoryFromPlaid !== null
          );

          const creditData = allAccount.filter(
            (item) =>
              item.accountType === "credit card" &&
              item.categoryFromPlaid !== null
          );

          const investmentData = allAccount.filter(
            (item) =>
              ![
                "checking",
                "savings",
                "credit card",
                "student",
                "loan",
                "auto",
                "business",
                "commercial",
                "construction",
                "consumer",
                "overdraft",
                "home equity",
                "line of credit",
                "mortgage",
              ].includes(item.accountType) && item.categoryFromPlaid !== null
          );

          const studentData = allAccount.filter(
            (item) =>
              [
                "student",
                "mortgage",
                "loan",
                "auto",
                "business",
                "commercial",
                "construction",
                "consumer",
                "overdraft",
                "home equity",
                "line of credit",
              ].includes(item.accountType) && item.categoryFromPlaid !== null
          );

          const cashData = allAccount.filter(
            (item) =>
              item.paidUsing === "Cash" && item.categoryFromPlaid !== null
          );

          const nullCategoryDataNullCategory = allAccount.filter(
            (item) => item.categoryFromPlaid === null
          );

          const resultObject = {
            allAccount,
            checkingSavingData,
            creditData,
            investmentData,
            studentData,
            nullCategoryDataNullCategory,
            cashData,
          };

          console.log("Final Result Object:", resultObject);
          setTransactions(resultObject);
        } catch (error) {
          console.error("Error fetching all pages:", error);
          swal("Error", "Failed to fetch Filter transactions", "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      await getTransactions();
      setUpdateState(!updateState);
    }
  };
  // Debounced function for API call
  const handleSearch = useCallback(
    debounce(async (query) => {
      console.log("Search Query before filtering Transaction:", query);

      if (!query) {
        await getTransactions();
        setUpdateState((prev) => !prev);
        return;
      }

      setLoading(true);
      try {
        let queryParam = `search=${query}&page=1`;
        if (selectedAccountName) {
          queryParam += `&accountName=${selectedAccountName}`;
        }
        console.log("Query Params: ", queryParam, selectedAccountName);
        let initialResponse = await BUDGET_API.fetchFilterTransaction(
          queryParam
        );

        if (
          !initialResponse ||
          initialResponse.status !== 200 ||
          !initialResponse.data
        ) {
          swal("Error", "Failed to fetch data", "error");
          return;
        }

        const totalPages = initialResponse.data.totalPages;
        let allTransactions = initialResponse.data.transactions || [];

        // Prepare API requests for remaining pages
        const pageRequests = [];
        for (let page = 2; page <= totalPages; page++) {
          let paginatedQueryParam = `search=${query}&page=${page}`;
          if (selectedAccountName) {
            paginatedQueryParam += `&accountName=${selectedAccountName}`;
          }
          pageRequests.push(
            BUDGET_API.fetchFilterTransaction(paginatedQueryParam)
          );
        }

        try {
          // Fetch all pages in parallel
          const responses = await Promise.all(pageRequests);

          // Combine results
          responses.forEach((response) => {
            if (
              response &&
              response.status === 200 &&
              response.data.transactions
            ) {
              allTransactions = allTransactions.concat(
                response.data.transactions
              );
            }
          });

          // Process data into categories
          const allAccount = allTransactions;

          const checkingSavingData = allAccount.filter(
            (item) =>
              (item.accountType === "checking" ||
                item.accountType === "savings") &&
              item.categoryFromPlaid !== null
          );

          const creditData = allAccount.filter(
            (item) =>
              item.accountType === "credit card" &&
              item.categoryFromPlaid !== null
          );

          const investmentData = allAccount.filter(
            (item) =>
              ![
                "checking",
                "savings",
                "credit card",
                "student",
                "loan",
                "auto",
                "business",
                "commercial",
                "construction",
                "consumer",
                "overdraft",
                "home equity",
                "line of credit",
                "mortgage",
              ].includes(item.accountType) && item.categoryFromPlaid !== null
          );

          const studentData = allAccount.filter(
            (item) =>
              [
                "student",
                "mortgage",
                "loan",
                "auto",
                "business",
                "commercial",
                "construction",
                "consumer",
                "overdraft",
                "home equity",
                "line of credit",
              ].includes(item.accountType) && item.categoryFromPlaid !== null
          );

          const cashData = allAccount.filter(
            (item) =>
              item.paidUsing === "Cash" && item.categoryFromPlaid !== null
          );

          const nullCategoryDataNullCategory = allAccount.filter(
            (item) => item.categoryFromPlaid === null
          );

          const resultObject = {
            allAccount,
            checkingSavingData,
            creditData,
            investmentData,
            studentData,
            nullCategoryDataNullCategory,
            cashData,
          };

          console.log("Final Search Result Object:", resultObject);
          setSearchTransactions(resultObject);
        } catch (error) {
          console.error("Error fetching all pages:", error);
          swal("Error", "Failed to fetch search transactions", "error");
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }, 500), // Debounce: 500ms delay
    []
  );

  // Handle input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    // handleSearch(e.target.value);
  };

  // const handleApplyFilter = async (filter) => {
  //   console.log("Filter Data before filtering Transaction:", filter);
  //   setDropdown(false);
  //   let categoryId = null;
  //   console.log("payload", filter);
  //   if (filter && Object.keys(filter).length > 0) {
  //     try {
  //       let payload = filter;
  //       console.log("payload", payload, filter);
  //       // if (filter && filter.categoryName && !filter.categoryId) {
  //       //   categoryId =
  //       //     categories &&
  //       //     categories.find((item) => item.categoryName === filter.categoryName)
  //       //       .id;
  //       //   payload.categoryId = categoryId;
  //       // }
  //       setLoading(true);
  //       let data = await DEATH_API.filterBudgetTransaction(payload);
  //       if (data && data.status === 200 && data.filteredTransactions) {
  //         swal("Success", data.message, "success");
  //         // const allAccount = data.filteredTransactions;
  //         const allAccount = data.filteredTransactions && data.filteredTransactions.map((item) => {
  //           // If amount is negative, convert it to positive
  //           if (item.amount && item.typeOfTransaction===null) {
  //             item.amount = -1*(item.amount);
  //           }
  //           return item;
  //         });
  //         const checkingSavingData = allAccount.filter(
  //           (item) => {
  //             return (
  //               (item.accountType === "checking" ||
  //                 item.accountType === "savings") &&
  //               item.categoryFromPlaid !== null
  //             );
  //           }
  //         );
  //         const creditData =allAccount.filter((item) => {
  //           return (
  //             item.accountType === "credit card" &&
  //             item.categoryFromPlaid !== null
  //           );
  //         });
  //         const investmentData = allAccount.filter((item) => {
  //           return (
  //             item.accountType !== "checking" &&
  //             item.accountType !== "savings" &&
  //             item.accountType !== "credit card" &&
  //             item.accountType !== "student" &&
  //             item.accountType !== "loan" &&
  //             item.accountType !== "auto" &&
  //             item.accountType !== "business" &&
  //             item.accountType !== "commercial" &&
  //             item.accountType !== "construction" &&
  //             item.accountType !== "consumer" &&
  //             item.accountType !== "overdraft" &&
  //             item.accountType !== "home equity" &&
  //             item.accountType !== "line of credit" &&
  //             item.accountType !== "mortgage" &&
  //             item.categoryFromPlaid !== null
  //           );
  //         });
  //         const studentData = allAccount.filter((item) => {
  //           return (
  //             (item.accountType === "student" ||
  //               item.accountType === "mortgage" ||
  //               item.accountType === "loan" ||
  //               item.accountType === "auto" ||
  //               item.accountType === "business" ||
  //               item.accountType === "commercial" ||
  //               item.accountType === "construction" ||
  //               item.accountType === "consumer" ||
  //               item.accountType === "overdraft" ||
  //               item.accountType === "home equity" ||
  //               item.accountType === "line of credit") &&
  //             item.categoryFromPlaid !== null
  //           );
  //         });
  //         const cashData = allAccount.filter((item) => {
  //           console.log("itemascascascasc", item);
  //           return item.paidUsing === "Cash" && item.categoryFromPlaid !== null;
  //         });
  //         console.log("cashData11", studentData);
  //         const nullCategoryDataNullCategory = allAccount.filter(
  //           (item) => {
  //             return item.categoryFromPlaid === null;
  //           }
  //         );
  //         const resultObject = {
  //           allAccount,
  //           checkingSavingData,
  //           creditData,
  //           investmentData,
  //           studentData,
  //           nullCategoryDataNullCategory,
  //           cashData,
  //         };
  //         console.log("resultObject111", resultObject);
  //         setTransactions(resultObject);
  //         // await getTransactions();
  //       }
  //       if (data && data.status === 400) {
  //         swal("Error", data.message, "error");
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //       setLoading(false);
  //     }
  //   } else {
  //     await getTransactions();
  //     setUpdateState(!updateState);
  //   }
  //   // setFilterData(null);
  // };
  const removeKey = async (keyToRemove) => {
    const newData = { ...filterData };
    console.log("newData", newData);
    delete newData[keyToRemove];
    if (keyToRemove === "categoryName") {
      delete newData["categoryId"];
      delete newData["category"];
    }
    if (keyToRemove === "subCategoryName") {
      delete newData["subCategoryId"];
      delete newData["category"];
    }
    handleApplyFilter(newData);
    setFilterData(newData);
  };

  const openModal = () => {
    console.log("Open Modal");
    setModalTitle("Edit Transaction");
    setAddModal(true);
  };
  const handleUpdateFormData = (data) => {
    let obj = data;
    // if (data && data.categoryId) {
    //   obj.categoryName =
    //     categories &&
    //     categories.find((item) => item.id === data.categoryId).categoryName;
    // }
    if (data && data.categoryId) {
      const category =
        categories && categories.find((item) => item.id === data.categoryId);
      if (category) {
        if (data.subCategoryId) {
          const subcategory =
            category.subCategories &&
            category.subCategories.find((sub) => sub.id === data.subCategoryId);
          if (subcategory) {
            obj.categoryName = subcategory.name;
          }
        } else {
          obj.categoryName = category.categoryName;
        }
      }
    }
    if (data && data.accountName && data.accountNumber) {
      obj.accountTitle = `${data.accountName} ${data.accountNumber}`;
    }
    if (
      data &&
      data.categoryFromPlaid &&
      !data.categoryId &&
      !data.subcategoryId
    ) {
      obj.categoryName = data.categoryFromPlaid;
    }
    if (data && data.amount) {
      if (data.amount < 0) {
        if (obj.typeOfTransaction === null) {
          obj.typeOfTransaction = "Expense";
        }
      } else {
        if (obj.typeOfTransaction === null) {
          obj.typeOfTransaction = "Income";
        }
      }
      obj.amount = data.amount;
    }
    console.log("updatedata", data, obj);
    setFormData(obj);
  };
  const handleHistoryCancel = () => {
    setIsHistoryModalOpen(false);
    setTransactionHistory(null);
  };
  const handleHistoryOpen = async (id) => {
    try {
      setLoading(true);
      const data = await DEATH_API.getTransactionHistory(id);
      if (data && data.data) {
        console.log("here in transaction history fetching");
        setTransactionHistory(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error");
    }
    setIsHistoryModalOpen(true);
  };
  const deleteLinkModule = async (cmIds) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Are you sure you would like to delete the selected Transactions?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          visible: true,
        },
        confirm: {
          text: "Yes",
          visible: true,
        },
      },
      dangerMode: true,
    });
  
    if (!willDelete) {
      swal("Cancelled", "Your Module is safe :)", "error");
      return;
    }
  
    setLoading(true);
  
    try {
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/budget-service`;
      const response = await axios.put(
        `${baseUrl}/delete/transactions`,
        { transactionIds: selectedRowKeys },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
  
      if (response && response.data.status === 200) {
        await getTransactions();
        swal("Success", response.data.message, "success");
      } else {
        swal("Error", "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Delete error:", error);
      swal("Error", "Failed to delete transactions", "error");
    } finally {
      setLoading(false);
    }
  };
  
  
  // const deleteLinkModule = async (cmIds) => {
  //   setLoading(true);
  //   swal({
  //     title: "Are you sure?",
  //     text: "Are you sure would you like to delete the selected Transactions?",
  //     icon: "warning",
  //     type: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   }).then(async (willDelete) => {
  //     if (willDelete) {
  //       try {
  //         // let payload = {
  //         //   cmIds: cmIds,
  //         // };
  //         // const resposnse = await DEATH_API.deleteLinkModule(payload);
  //         const userToken = localStorage.getItem("userLoginToken");
  //         const baseUrl = `${ROUTES.BASE_URL}/budget-service`;
  //         const response = await axios.put(
  //           `${baseUrl}/delete/transactions`,
  //           { transactionIds: selectedRowKeys },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${userToken}`,
  //             },
  //           }
  //         );
  //         if (response && response.data.status === 200) {
  //           await getTransactions();
  //           //  await getContactList();
  //           swal("Success", response.data.message, "success");
  //         }
  //       } catch (error) {
  //         console.log(error);
  //       }finally {
  //         setLoading(false); 
  //       }
  //     } else {
  //       swal("Cancelled", "Your Module is safe :)", "error");
  //     }
  //   });
  // };
  const deleteSelectedTransaction = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete these Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteBudgetTransaction(id);
          setLoading(false);
          if (filterData) {
            await handleApplyFilter(filterData);
          } else {
            await getTransactions();
          }
          setUpdateState(!updateState);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Transaction has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };

  const selectedRowsDataKeys = (data) => {
    setSelectedRowKeys(data);
  };
  // const searchData = (array, query) => {
  //   const lowercaseQuery = query.toLowerCase();
  //   return array && array.filter((item) => {
  //     const description = item.description ? item.description.toLowerCase() : '';
  //     const notes = item.notes ? item.notes.toLowerCase() : '';
  //     const itemName = item.itemName ? item.itemName.toLowerCase() : '';
  //     const categoryFromPlaid = item.categoryFromPlaid ? item.categoryFromPlaid.toLowerCase() : '';
  //     const subCategory = item.subCategory ? item.subCategory.toLowerCase() : '';
  //     return (
  //       description.includes(lowercaseQuery) ||
  //       notes.includes(lowercaseQuery) ||
  //       itemName.includes(lowercaseQuery) ||
  //       categoryFromPlaid.includes(lowercaseQuery) ||
  //       subCategory.includes(lowercaseQuery)
  //     );
  //   });
  // };
  // const filteredData = transactions && transactions.allAccount ? searchData(transactions.allAccount , searchQuery) : [];
  // filter data according to selected tab
  const searchData = (transactions, query) => {
    const lowercaseQuery = query.toLowerCase();
    let arrayToSearch = [];
    let tabIndex = selectedIndex;
    // Determine which array to search based on the tab index from state
    switch (tabIndex) {
      case 0: // All Accounts
        arrayToSearch = transactions.allAccount;
        break;
      case 1: // Checking/Saving
        arrayToSearch = transactions.checkingSavingData;
        break;
      case 2: // Credit Data
        arrayToSearch = transactions.creditData;
        break;
      // case 3: // Investments
      //   arrayToSearch = transactions.investmentData;
      //   break;
      // case 4: // Student Data
      //   arrayToSearch = transactions.studentData;
      case 3: // uncategorized Data
        arrayToSearch = transactions.nullCategoryDataNullCategory;
        break;
      default:
        break;
    }
    // Perform the search
    return arrayToSearch.filter((item) => {
      const description = item.description
        ? item.description.toLowerCase()
        : "";
      const notes = item.notes ? item.notes.toLowerCase() : "";
      const itemName = item.itemName ? item.itemName.toLowerCase() : "";
      const categoryFromPlaid = item.categoryFromPlaid
        ? item.categoryFromPlaid.toLowerCase()
        : "";
      const subCategory = item.subCategory
        ? item.subCategory.toLowerCase()
        : "";
      const amountString = item.amount
        ? item.amount.toString().toLowerCase()
        : "";
      // const dateString = item.date ? item.date.toLowerCase() : '';
      const dateString = item.date
        ? new Date(item.date)
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
            .replace(/\//g, "-")
        : "";
      return (
        description.includes(lowercaseQuery) ||
        notes.includes(lowercaseQuery) ||
        itemName.includes(lowercaseQuery) ||
        categoryFromPlaid.includes(lowercaseQuery) ||
        subCategory.includes(lowercaseQuery) ||
        amountString.includes(lowercaseQuery) || // Search in amount
        dateString.includes(lowercaseQuery) // Search in date
      );
    });
  };
  const filteredData =
    transactions && transactions ? searchData(transactions, "") : [];

  console.log("filteredData", filteredData, selectedIndex);
  const Tabs = [
    {
      id: 1,
      name: "All Accounts",
      component: (
        <AllAccount
          handleOpen={openModal}
          handleUpdateFormData={handleUpdateFormData}
          handleHistoryOpen={handleHistoryOpen}
          handleHistoryCancel={handleHistoryCancel}
          deleteTransaction={deleteSelectedTransaction}
          transactions={transactions && transactions}
          filterData={filteredData && filteredData}
          selectedRowsDataKeys={selectedRowsDataKeys}
          searchQuery={searchQuery && searchQuery}
          selectedRowKeys={selectedRowKeys}
          banksData={clientBanks && clientBanks}
        />
      ),
    },
    {
      id: 2,
      name: "Checking and Saving",
      component: (
        <CheckingSaving
          handleOpen={openModal}
          handleUpdateFormData={handleUpdateFormData}
          handleHistoryOpen={handleHistoryOpen}
          handleHistoryCancel={handleHistoryCancel}
          deleteTransaction={deleteSelectedTransaction}
          transactions={transactions && transactions}
          state={updateState}
          filterData={filteredData && filteredData}
          searchQuery={searchQuery && searchQuery}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
          banksData={clientBanks && clientBanks}
          setSelectedAccountName={setSelectedAccountName}
        />
      ),
    },
    // {
    //   id: 3,
    //   name: "Loans",
    //   component: (
    //     <LoanAccount
    //       handleOpen={openModal}
    //       handleUpdateFormData={handleUpdateFormData}
    //       handleHistoryOpen={handleHistoryOpen}
    //       handleHistoryCancel={handleHistoryCancel}
    //       deleteTransaction={deleteSelectedTransaction}
    //       transactions={transactions && transactions}
    //       state={updateState}
    //       filterData={filteredData && filteredData}
    //       searchQuery={searchQuery && searchQuery}
    //       selectedRowsDataKeys={selectedRowsDataKeys}
    //       selectedRowKeys={selectedRowKeys}
    //     />
    //   ),
    // },
    {
      id: 4,
      name: "Credit Cards",
      component: (
        <CreditCard
          handleOpen={openModal}
          handleUpdateFormData={handleUpdateFormData}
          handleHistoryOpen={handleHistoryOpen}
          handleHistoryCancel={handleHistoryCancel}
          deleteTransaction={deleteSelectedTransaction}
          transactions={transactions && transactions}
          state={updateState}
          filterData={filteredData && filteredData}
          searchQuery={searchQuery && searchQuery}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
          banksData={clientBanks && clientBanks}
        />
      ),
    },
    // {
    //   id: 5,
    //   name: "Investments",
    //   component: (
    //     <Investment
    //       handleOpen={openModal}
    //       handleUpdateFormData={handleUpdateFormData}
    //       handleHistoryOpen={handleHistoryOpen}
    //       handleHistoryCancel={handleHistoryCancel}
    //       deleteTransaction={deleteSelectedTransaction}
    //       transactions={transactions && transactions}
    //       state={updateState}
    //       filterData={filteredData && filteredData}
    //       searchQuery={searchQuery && searchQuery}
    //       selectedRowsDataKeys={selectedRowsDataKeys}
    //       selectedRowKeys={selectedRowKeys}
    //     />
    //   ),
    // },
    {
      id: 6,
      name: "Cash",
      component: (
        <CashTab
          handleOpen={openModal}
          handleUpdateFormData={handleUpdateFormData}
          handleHistoryOpen={handleHistoryOpen}
          handleHistoryCancel={handleHistoryCancel}
          deleteTransaction={deleteSelectedTransaction}
          transactions={transactions && transactions}
          state={updateState}
          filterData={filteredData && filteredData}
          searchQuery={searchQuery && searchQuery}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
        />
      ),
    },
    {
      id: 7,
      name: "Uncategorized",
      component: (
        <UnCategorized
          handleOpen={openModal}
          handleUpdateFormData={handleUpdateFormData}
          handleHistoryOpen={handleHistoryOpen}
          handleHistoryCancel={handleHistoryCancel}
          deleteTransaction={deleteSelectedTransaction}
          transactions={transactions && transactions}
          state={updateState}
          filterData={filteredData && filteredData}
          searchQuery={searchQuery && searchQuery}
          selectedRowsDataKeys={selectedRowsDataKeys}
          selectedRowKeys={selectedRowKeys}
        />
      ),
    },
  ];

  const handleCancelAddModal = () => {
    setAddModal(false);
    setFormData(null);
    setModalTitle("Add Transaction");
  };
  const handleSaveAddModal = async () => {
    console.log(formData);
    setAddModal(false);
    let categoryId = null;
    let accountId = null;
    if (modalTitle === "Add Transaction") {
      try {
        let payload = {
          ...formData,
          amount:
            formData.typeOfTransaction === "Expense"
              ? -Math.abs(formData.amount)
              : Math.abs(formData.amount),
        };
        // if (formData && formData.categoryName) {
        //   categoryId =
        //     categories &&
        //     categories.find(
        //       (item) => item.categoryName === formData.categoryName
        //     ).id;
        //   payload.categoryId = categoryId;
        // }
        if (
          formData &&
          formData.accountTitle &&
          formData.accountTitle != "Cash"
        ) {
          accountId =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.accountTitle
            ).bankId;
          const clientAccount =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.accountTitle
            );
          payload.cmId = clientAccount.cmId ? clientAccount.cmId : null;
          payload.accountId = accountId;
          payload.bankName =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.accountTitle
            ).bankName;
          payload.subType =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.accountTitle
            ).subType;
          payload.accountNumber =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.accountTitle
            ).accountNumber;
          payload.accountName = clientBanks.find(
            (item) => item.accountTitle === formData.accountTitle
          ).accountName;
        } else {
          payload.paidUsing = "Cash";
        }

        setLoading(true);
        let data = await DEATH_API.createClientBudgetTransaction(payload);
        if (data && data.status === 200) {
          swal("Success", data.message, "success");
          if (filterData) {
            await handleApplyFilter(filterData);
          } else {
            await getTransactions();
          }
          setUpdateState(!updateState);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let payload = {
          ...formData,
          amount:
            formData.typeOfTransaction === "Expense"
              ? -Math.abs(formData.amount)
              : Math.abs(formData.amount),
          // formData.cmId
          // ? Math.abs(formData.amount)
          // : (formData.typeOfTransaction === "Expense"
          //     ? -Math.abs(formData.amount)
          //     : Math.abs(formData.amount)
          //   ),
          // amount:
          //   formData.typeOfTransaction === "Expense"
          //     ? -Math.abs(formData.amount)
          //     : Math.abs(formData.amount),
        };
        // if (formData && formData.categoryName) {
        //   categoryId =
        //     categories &&
        //     categories.find(
        //       (item) => item.categoryName === formData.categoryName
        //     ).id;
        //   payload.categoryId = categoryId;
        // }
        const matchedBank =
          clientBanks &&
          clientBanks.find(
            (item) => item.accountTitle === formData.accountTitle
          );
        console.log("matchedBank", matchedBank, formData.accountTitle);
        if (formData && formData.accountTitle && matchedBank) {
          accountId = matchedBank.bankId;
          // clientBanks &&
          // clientBanks.find(
          //   (item) => item.accountTitle === formData.accountTitle
          // ).accountId;
          payload.accountId = accountId;
          payload.bankName = matchedBank.bankName;
          // clientBanks &&
          // clientBanks.find(
          //   (item) => item.accountTitle === formData.accountTitle
          // ).bankName;
          payload.subType = matchedBank.subType;
          // clientBanks &&
          // clientBanks.find(
          //   (item) => item.accountTitle === formData.accountTitle
          // ).subType;
          payload.accountType = payload.subType;
          payload.accountName = matchedBank.accountName;
          payload.accountNumber = matchedBank.accountNumber;
          payload.cmId = matchedBank.cmId ? matchedBank.cmId : null;
          // clientBanks.find(
          //   (item) => item.accountTitle === formData.accountTitle
          // ).accountName;
        }
        let data = await DEATH_API.updateBudgetTransaction(
          formData.id,
          payload
        );
        if (data && data.status === 200) {
          swal("Success", data.message, "success");
          if (filterData) {
            await handleApplyFilter(filterData);
          } else {
            await getTransactions();
          }
          setUpdateState(!updateState);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }

    setFormData(null);
    setModalTitle("Add Transaction");
  };
  const handleInputChnage = (name, value) => {
    // console.log('ev', name,value, formData)
    if (name === "category") {
      console.log("value", value);
      if (value.includes("-")) {
        const [subcategoryName, categoryName] = value
          .split("-")
          .map((item) => item.trim());
        console.log("Subcategory Name:", subcategoryName);
        console.log("Category Name:", categoryName);

        // Find category and subcategory IDs
        let categoryId = null;
        let subcategoryId = null;
        categories &&
          categories.forEach((category) => {
            if (category.categoryName === categoryName) {
              categoryId = category.id;
              const subcategory =
                category.subCategories &&
                category.subCategories.find(
                  (sub) => sub.name === subcategoryName
                );
              if (subcategory) {
                subcategoryId = subcategory.id;
              }
            }
          });

        console.log("Category ID:", categoryId);
        console.log("Subcategory ID:", subcategoryId);
        setFormData({
          ...formData,
          ["categoryName"]: subcategoryName,
          ["categoryFromPlaid"]: categoryName,
          ["categoryId"]: categoryId,
          ["subCategoryId"]: subcategoryId,
          ["subCategory"]: subcategoryName,
        });
      } else {
        let categoryId = null;
        categoryId =
          categories &&
          categories.find((item) => item.categoryName === value).id;
        setFormData({
          ...formData,
          ["categoryName"]: value,
          ["categoryId"]: categoryId,
          ["subCategoryId"]: null,
          ["subCategory"]: null,
          ["categoryFromPlaid"]: value,
        });
      }
    } else {
      if (name === "paidUsing" && formData && formData.paidUsing && formData.paidUsing === value) {
        const updatedForm = { ...formData };
        delete updatedForm.paidUsing;
        setFormData(updatedForm);
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    }
  };
  const getCategories = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getCategories("false");
      if (data && data.status === 200 && data.data) {
        setCategories(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getUpdatedBalance = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getAccountUpdatedBalance();
      if (data && data.status === 200 && data.data) {
        console.log("data.data", data.data);
        setBanksCredit(data.data);
        // setCategories(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetTransaction();
      if (data && data.data) {
        const sortedDataD = data.data.sort((a, b) => {
          const dateA = new Date(a.date || ""); // Convert `a.date` to a Date object
          const dateB = new Date(b.date || ""); // Convert `b.date` to a Date object

          return dateB - dateA; // Sort in descending order
        });
        console.log("sortedData", sortedDataD);
        const allAccount = data.data;
        // const allAccount = data.data.map((item) => {
        //   // If amount is negative, convert it to positive
        //   if (item.amount && item.typeOfTransaction===null) {
        //     item.amount = -1*(item.amount);
        //   }
        //   return item;
        // });
        const checkingSavingData = allAccount.filter((item) => {
          return (
            (item.accountType === "checking" ||
              item.accountType === "savings") &&
            item.categoryFromPlaid !== null
          );
        });
        const creditData = allAccount.filter((item) => {
          return (
            item.accountType === "credit card" &&
            item.categoryFromPlaid !== null
          );
        });
        const investmentData = allAccount.filter((item) => {
          return (
            item.accountType !== "checking" &&
            item.accountType !== "savings" &&
            item.accountType !== "credit card" &&
            item.accountType !== "student" &&
            item.accountType !== "loan" &&
            item.accountType !== "auto" &&
            item.accountType !== "business" &&
            item.accountType !== "commercial" &&
            item.accountType !== "construction" &&
            item.accountType !== "consumer" &&
            item.accountType !== "overdraft" &&
            item.accountType !== "home equity" &&
            item.accountType !== "line of credit" &&
            item.accountType !== "mortgage" &&
            item.categoryFromPlaid !== null
          );
        });
        const studentData = allAccount.filter((item) => {
          return (
            (item.accountType === "student" ||
              item.accountType === "mortgage" ||
              item.accountType === "loan" ||
              item.accountType === "auto" ||
              item.accountType === "business" ||
              item.accountType === "commercial" ||
              item.accountType === "construction" ||
              item.accountType === "consumer" ||
              item.accountType === "overdraft" ||
              item.accountType === "home equity" ||
              item.accountType === "line of credit") &&
            item.categoryFromPlaid !== null
          );
        });
        const cashData = allAccount.filter((item) => {
          return item.paidUsing === "Cash" && item.categoryFromPlaid !== null;
        });
        const nullCategoryDataNullCategory = allAccount.filter((item) => {
          return item.categoryFromPlaid === null;
        });

        //shah
        const resultObject = {
          allAccount,
          checkingSavingData,
          creditData,
          investmentData,
          studentData,
          nullCategoryDataNullCategory,
          cashData,
        };
        setTransactions(resultObject);
        console.log("alldata", resultObject);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // getTransactions();
    // getCategories();
    getAllResults();
  }, []);
  // useEffect(() => {
  //  if(location && location.state && location.state.filterValues){
  //   setFilterData(location.state.filterValues);
  //   handleApplyFilter(location.state.filterValues);
  //  }
  // }, []);

  const getAllResults = async () => {
    if (location && location.state && location.state.filterValues) {
      console.log("location:", location.state.filterValues.id);
      let filterObj = {
        categoryId:
          location.state.filterValues && location.state.filterValues.id,
        categoryName:
          location.state.filterValues &&
          location.state.filterValues.categoryName,
        startDate:
          location.state.filterValues && location.state.filterValues.startDate,
        endDate:
          location.state.filterValues && location.state.filterValues.endDate,
      };
      console.log("location", filterObj);
      setFilterData(filterObj);
      await handleApplyFilter(filterObj);
      history.replace({ ...location, state: null });
    } else {
      await getTransactions();
    }
    // await getUpdatedBalance();
    await getBankDetails();
    await getCategories();
  };
  const getUserTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankAccountDetails();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getBankDetails = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankDetails();
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            bankId: account.id,
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
            cmId: account.cmId && account.cmId,
          };
        });
        console.log("newArray", newArray);
        // setClientBanks(newArray)
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const convertToCSV = () => {
    // Define the order of headers with desired names
    const headerOrder = [
      { key: "date", name: "Date" },
      { key: "itemName", name: "Item Name" },
      { key: "description", name: "Description" },
      { key: "amount", name: "Amount" },
      { key: "categoryFromPlaid", name: "Category" },
      { key: "bankName", name: "Bank Name" },
      { key: "accountType", name: "Account Type" },
      { key: "accountNumber", name: "Account Number" },
      { key: "typeOfTransaction", name: "Type of Transaction" },
      { key: "paidUsing", name: "Paid Using" },
      { key: "notes", name: "Notes" },
    ];

    // Filter out keys to exclude from export
    const excludedKeys = ["deleted", "clientId", "enable", "id", "accountId"];

    // Get the headers in the desired order with desired names, excluding excluded keys
    const headers = headerOrder
      .filter((header) => !excludedKeys.includes(header.key))
      .map((header) => header.name)
      .join(",");

    // Convert data to CSV, excluding excluded keys and using the specified header order
    const csvData =
      transactions &&
      transactions.allAccount
        .map((item) =>
          headerOrder
            .filter((header) => !excludedKeys.includes(header.key))
            .map((header) => {
              if (header.key === "date") {
                const date = new Date(item[header.key]);
                // Format date as mm/dd/yyyy
                return `${(date.getMonth() + 1)
                  .toString()
                  .padStart(2, "0")}/${date
                  .getDate()
                  .toString()
                  .padStart(2, "0")}/${date.getFullYear()}`;
              } else if (header.key === "amount") {
                // Format amount with dollar sign and toFixed(2)
                return `$${parseFloat(item[header.key]).toFixed(2)}`;
              } else if (header.key === "accountNumber") {
                return `${"****" + item[header.key]}`;
              } else {
                return item[header.key];
              }
            })
            .join(",")
        )
        .join("\n");

    return `${headers}\n${csvData}`;
  };

  const downloadCSV = () => {
    if (
      !transactions ||
      !transactions.allAccount ||
      transactions.allAccount.length === 0
    ) {
      swal("Error", "No data available for download", "error");
      return;
    }
    const csvData = convertToCSV();
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Transaction.csv");
    document.body.appendChild(link);
    link.click();
  };
  // Function to read the file
  const uploadTransactions = async (data) => {
    let payload = {
      transactionData: data,
    };
    try {
      setLoading(true);
      let data = await DEATH_API.transactionUpload(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        if (filterData) {
          await handleApplyFilter(filterData);
        } else {
          await getTransactions();
        }
        setUpdateState(!updateState);
      }
      if (data && data.status === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const csvData = reader.result;
        const jsonData = convertCSVToJSON(csvData);
        console.log("JSON Data:", jsonData);

        if (jsonData) {
          uploadTransactions(jsonData);
        }
      };
      reader.readAsText(file);
    } else {
      alert("Please select a file.");
    }
  };
  // Function to convert CSV to JSON based on headerOrder
  const parseCSVLine = (line) => {
    const values = [];
    let current = "";
    let inQuotes = false;

    for (let char of line) {
      if (char === '"' && inQuotes) {
        inQuotes = false;
      } else if (char === '"' && !inQuotes) {
        inQuotes = true;
      } else if (char === "," && !inQuotes) {
        values.push(current.trim());
        current = "";
      } else {
        current += char;
      }
    }
    values.push(current.trim());
    return values;
  };

  const convertCSVToJSON = (csv) => {
    const headerOrder = [
      { key: "date", name: "Date" },
      { key: "itemName", name: "Item Name" },
      { key: "description", name: "Description" },
      { key: "amount", name: "Amount" },
      { key: "categoryFromPlaid", name: "Category" },
      { key: "bankName", name: "Bank Name" },
      { key: "accountType", name: "Account Type" },
      { key: "accountNumber", name: "Account Number" },
      { key: "typeOfTransaction", name: "Type of Transaction" },
      { key: "paidUsing", name: "Paid Using" },
      { key: "notes", name: "Notes" },
    ];

    const lines = csv.split("\n").filter((line) => line.trim() !== "");
    const headers = parseCSVLine(lines[0]);
    // const headers = lines[0].split(',').map(header => header.trim());
    const jsonData = lines
      .slice(1)
      .map((line) => {
        const values = parseCSVLine(line);
        // const values = line.split(',').map(value => value.trim());
        const jsonItem = {};
        if (values.every((value) => value === "")) {
          return null; // Exclude empty rows
        }
        headers.forEach((header, index) => {
          const headerMapping = headerOrder.find((h) => h.name === header);
          if (headerMapping) {
            jsonItem[headerMapping.key] = values[index];
          }
        });

        // Additional formatting for specific fields if necessary
        // if (jsonItem.date) {
        //   const date = new Date(jsonItem.date);
        //   jsonItem.date = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
        // }
        if (jsonItem.amount) {
          // jsonItem.amount = `${parseFloat(jsonItem.amount).toFixed(2)}`;
          const sanitizedAmount = jsonItem.amount.replace(/[$,"]/g, "");
          console.log(
            `Original amount: ${jsonItem.amount}, Sanitized amount: ${sanitizedAmount}`
          );
          if (!isNaN(parseFloat(sanitizedAmount))) {
            jsonItem.amount = parseFloat(sanitizedAmount).toFixed(2);
          } else {
            jsonItem.amount = "0.00"; // Default to 0.00 if parsing fails
          }
        }
        if (jsonItem.accountNumber) {
          jsonItem.accountNumber = `${jsonItem.accountNumber.slice(-4)}`;
        }

        return jsonItem;
      })
      .filter((item) => item !== null);
    return jsonData;
  };
  const handleCancelUploadModal = () => {
    setUploadModal(false);
  };
  const handleConfirmUploadModal = () => {
    setUploadModal(false);
  };
  const handleChange = (name, value) => {
    if (name === "category") {
      console.log("value", value);
      if (value.includes("-")) {
        const [subcategoryName, categoryName] = value
          .split("-")
          .map((item) => item.trim());
        console.log("Subcategory Name:", subcategoryName);
        console.log("Category Name:", categoryName);

        // Find category and subcategory IDs
        let categoryId = null;
        let subcategoryId = null;
        categories &&
          categories.forEach((category) => {
            if (category.categoryName === categoryName) {
              categoryId = category.id;
              const subcategory =
                category.subCategories &&
                category.subCategories.find(
                  (sub) => sub.name === subcategoryName
                );
              if (subcategory) {
                subcategoryId = subcategory.id;
              }
            }
          });

        console.log("Category ID:", categoryId);
        console.log("Subcategory ID:", subcategoryId);
        setEditModalData({
          ...editModalData,
          ["categoryName"]: subcategoryName,
          ["categoryFromPlaid"]: categoryName,
          ["categoryId"]: categoryId,
          ["subCategoryId"]: subcategoryId,
          ["subCategory"]: subcategoryName,
        });
      } else {
        let categoryId = null;
        categoryId =
          categories &&
          categories.find((item) => item.categoryName === value).id;
        setEditModalData({
          ...editModalData,
          ["categoryName"]: value,
          ["categoryId"]: categoryId,
          ["subCategoryId"]: null,
          ["subCategory"]: null,
          ["categoryFromPlaid"]: value,
        });
      }
    } else {
      setEditModalData({
        ...editModalData,
        [name]: value,
      });
    }
  };
  const handleCancelEditModal = () => {
    setEditModal(false);
    setEditModalData(null);
  };
  const handleDeleteEditModal = async () => { 
    setEditModal(false);
    // let payload = {
    //   ...editModalData,
    // };
    // let accountId = null;
    // const matchedBank =
    //   clientBanks &&
    //   clientBanks.find(
    //     (item) => item.accountTitle === editModalData.accountTitle
    //   );
    // if (editModalData && editModalData.accountTitle && matchedBank) {
    //   accountId = matchedBank.accountId;
    //   payload.accountId = accountId;
    //   payload.bankName = matchedBank.bankName;
    //   payload.subType = matchedBank.subType;
    //   payload.accountType = payload.subType;
    //   payload.accountName = matchedBank.accountName;
    //   payload.accountNumber = matchedBank.accountNumber;
    // }
    console.log("editmodal data", editModalData, selectedRowKeys);
    try {
      setLoading(true);
      // const userToken = localStorage.getItem("userLoginToken");
      // const baseUrl = `${ROUTES.BASE_URL}/budget-service`;
      // const response = await axios.put(
      //   `${baseUrl}/delete/transactions`,
      //   { transactionIds: selectedRowKeys && selectedRowKeys },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${userToken}`,
      //     },
      //   }
      // );
      // console.log("response", response);
      // if (response && response.data && response.data.status === 200) {
      //   swal("Success", response.data.message, "success");
      //   const cmIds =
      //     transactions && transactions.allAccount && selectedRowKeys
      //       ? transactions.allAccount
      //           .filter((item) => selectedRowKeys.includes(item.id))
      //           .map((item) => (item.hasOwnProperty("cmId") ? item.cmId : null))
      //           .filter((cmId) => cmId !== undefined && cmId !== null)
      //       : [];
      //   console.log("cmIds", cmIds);
      //   deleteLinkModule(cmIds);
        deleteLinkModule();
      // }
      if (filterData) {
        await handleApplyFilter(filterData);
      } 
      // else {
      //   await getTransactions();
      // }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error && error.data && error.data.message) {
        swal("Success", error.data.message, "success");
      }
      console.error("Error fetching user data:", error);
    }
    setSelectedRowKeys([]);
    setEditModalData(null);
  };
  const handleSaveEditModal = async () => {
    setEditModal(false);
    let payload = {
      ...editModalData,
    };
    let accountId = null;
    const matchedBank =
      clientBanks &&
      clientBanks.find(
        (item) => item.accountTitle === editModalData.accountTitle
      );
    if (editModalData && editModalData.accountTitle && matchedBank) {
      accountId = matchedBank.accountId;
      payload.accountId = accountId;
      payload.bankName = matchedBank.bankName;
      payload.subType = matchedBank.subType;
      payload.accountType = payload.subType;
      payload.accountName = matchedBank.accountName;
      payload.accountNumber = matchedBank.accountNumber;
    }
    var arrayOfObjects = createArrayOfObjects(selectedRowKeys, payload);
    console.log("editmodal data", selectedRowKeys, payload, arrayOfObjects);
    try {
      setLoading(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/budget-service`;
      const response = await axios.put(
        `${baseUrl}/update/transactions`,
        { transactions: arrayOfObjects },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response);
      if (response && response.data && response.data.status === 200) {
        swal("Success", response.data.message, "success");
      }
      if (filterData) {
        await handleApplyFilter(filterData);
      } else {
        await getTransactions();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error && error.data && error.data.message) {
        swal("Success", error.data.message, "success");
      }
      console.error("Error fetching user data:", error);
    }
    setSelectedRowKeys([]);
    setEditModalData(null);
  };
  function createArrayOfObjects(keys, details) {
    var result = [];
    keys.forEach(function (key) {
      var newObj = Object.assign({}, details); // Clone categoryDetails object
      newObj.id = key; // Add id property with value from selectedKeys
      result.push(newObj); // Push the new object to result array
    });
    return result;
  }
  const userRole = localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client"
  return (
    <div className="addBudgetMain" style={{ position: "relative" }}>
      <div className="addbudgetSection">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2rem",
            flexWrap: "wrap",
          }}
        >
          <div className="addTitle">
            Transactions{" "}
            <span>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}
                      >
                        Dashboard
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item>
                        <div
                          onClick={() => {
                            history.push("/budget/add/transaction");
                          }}
                        >
                          Transactions
                        </div>
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}
                      >
                        Budget
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item
                      // style={{ cursor: "not-allowed", opacity: "0.7" }}
                      >
                        <div
                          onClick={() => {
                            history.push("/budget/transaction/recurring");
                          }}
                        >
                          Recurring
                        </div>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            {filterData &&
              Object.keys(filterData).map((key) => {
                if (
                  key === "categoryId" ||
                  key === "subCategoryId" ||
                  key === "category"
                ) {
                  return null;
                }
                const value = filterData[key];
                return (
                  <div
                    key={key}
                    className="savebutton"
                    style={{ width: "fit-content" }}
                  >
                    {value}
                    <span
                      className="custom-footer-text"
                      onClick={() => {
                        removeKey(key);
                      }}
                    >
                      <Icon
                        type="close-circle"
                        style={{
                          marginBottom: "3px",
                          marginLeft: "8px",
                          fontWeight: "800",
                          fontSize: "18px",
                        }}
                      />{" "}
                    </span>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="budgetcreate" style={{ gap: "1rem", flexWrap: "wrap" }}>
          <div style={{ marginBottom: "0px" }}>
            <input
              className="searchStyle"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="filterIcons" onClick={downloadCSV}>
            <img src={downloadIcon} height={22} width={24} alt="icon"></img>
          </div>
          <div
            className="filterIcons"
            onClick={() => {
              setDropdown(!dropdown);
            }}
          >
            <img src={filterIcon} height={24} width={24} alt="icon"></img>
          </div>
          <Modal width={300} visible={dropdown} footer={null} closable={false}>
            <h3 className="inputTitle">Filter Data</h3>
            <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="Choose Primary Category"
              allowClear
              // treeDefaultExpandAll
              value={filterData && filterData.category}
              onChange={(value, label, extra) => {
                const selectedNode = extra.triggerNode;
                const parentNode = selectedNode && selectedNode.props.label;
                const selectedCategory = parentNode
                  ? `${value}-${parentNode}`
                  : value;
                console.log("selectedCategory", selectedCategory);
                handleFilterChnage("category", selectedCategory);
              }}
            >
              {categories &&
                categories.map((category) => {
                  let parentLabel = category.categoryName;
                  return (
                    <TreeNode
                      key={category.id}
                      value={category.categoryName}
                      title={category.categoryName}
                    >
                      {category.subCategories.map((subCategory, index) => (
                        <TreeNode
                          key={`${category.id}-${index}`}
                          value={subCategory.name}
                          title={subCategory.name}
                          label={parentLabel}
                        />
                      ))}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
            {/*  <Select
              showSearch
              placeholder="Select Category"
              value={filterData && filterData.categoryName}
              onChange={(value, id) => {
                console.log("value", value);
                handleFilterChnage("categoryName", value);
              }}
            >
              {categories &&
                categories.map((item, index) => (
                  <Option key={index} value={item.categoryName}>
                    {item.categoryName}
                  </Option>
                ))}
              </Select> */}
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
                marginTop: "1rem",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Start Date"
              name="date"
              value={
                filterData &&
                filterData.startDate &&
                moment(filterData.startDate)
              }
              id="newDate"
              onChange={(date, dateString) => {
                handleFilterChnage("startDate", dateString);
              }}
            />
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
                marginTop: "1rem",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="End Date"
              name="date"
              value={
                filterData && filterData.endDate && moment(filterData.endDate)
              }
              id="newDate"
              onChange={(date, dateString) => {
                handleFilterChnage("endDate", dateString);
              }}
            />
            <button
              className="savebutton"
              style={{ width: "100%", marginTop: "1rem" }}
              onClick={() => {
                handleApplyFilter(filterData && filterData);
              }}
            >
              Apply
            </button>
            <button
              className="cancelbutton"
              style={{ width: "100%", marginTop: "1rem" }}
              onClick={() => {
                handleCancelfilter();
              }}
            >
              Cancel
            </button>
          </Modal>
          {(!financialAccess || !financialAccess.hideTransactions) && <button
            className="addbuttonassets"
            onClick={() => {
              setCategoryModal(true);
            }}
          >
            {" "}
            + Add Category
          </button>}
          {(!financialAccess || !financialAccess.hideTransactions) && <button
            className="addbuttonassets"
            onClick={() => {
              setAddModal(true);
            }}
          >
            {" "}
            + Add Transaction
          </button>}
        </div>
      </div>
      <div className="TabSection">
        <Tab onTabSelected={onTabSelected}>
          {Tabs.map((tab, index) => (
            <TabItem key={tab.id}>{tab.name}</TabItem>
          ))}
        </Tab>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "end",
          justifyContent: "end",
          gap: "1rem",
          position:'relative'
        }}
      >
        {loading && (
          <span
            className="new-transaction-loader"
            style={{ alignSelf: "center" }}
          ></span>
        )}
        {userRole && <button
          className="savebutton"
          style={{ width: "fit-content" }}
          onClick={() => {
            getTransactions();
          }}
        >
          {" "}
          Refresh Transactions{" "}
        </button>}
        {(!financialAccess || !financialAccess.hideTransactions) && <button
          className="savebutton"
          style={{ width: "fit-content" }}
          onClick={() => {
            history.push("/budget/add/transaction/rules");
          }}
        >
          {" "}
          Add Rules{" "}
        </button>}
        {selectedRowKeys && selectedRowKeys.length > 0 && userRole && (
          <button
            className="savebutton"
            style={{ width: "fit-content" }}
            onClick={() => {
              setEditModal(true);
            }}
          >
            {" "}
            Edit Multiple{" "}
          </button>
        )}
        {(!financialAccess || !financialAccess.hideTransactions) && <button
          className="savebutton"
          style={{ width: "fit-content" }}
          onClick={() => {
            setUploadModal(true);
          }}
        >
          {" "}
          Import Transactions{" "}
        </button>}
      </div>
      <Modal visible={uploadModal} footer={null} closable={false} centered>
        <h3 className="modaltitle">Upload Transactions</h3>
        <h3 className="modaltitle">
          Ensure you upload is in csv format and ensure these are the columns in
          your upload:
        </h3>
        <img
          src={fileColumn}
          style={{ width: "100%", height: "1.75rem" }}
        ></img>
        <div className="buttonsMain">
          <input
            id="file"
            type="file"
            name="file"
            className="inputUpload"
            onChange={handleFileUpload}
            style={{
              width: "80%",
              display: "none",
              marginRight: "10px",
              display: "none",
            }}
            accept=".csv"
          />
          <label
            className="uploadLabel file"
            htmlFor="file"
            style={{
              width: "50%",
              alignItems: "end",
              marginTop: "8px",
              justifyContent: "end",
            }}
            onClick={handleConfirmUploadModal}
          >
            <span
              className="fileButton"
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "none",
                paddingInline: "8px",
              }}
            >
              Confirm
            </span>{" "}
          </label>
          {/*<button
              className="savebutton"
              onClick={() => {
                handleConfirmUploadModal();
              }}
            >
              Confirm
            </button> */}
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancelUploadModal();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <div className="ComponentSection">{Tabs[selectedIndex].component}</div>
      {addModal && (
        <TransactionModal
          title={modalTitle && modalTitle}
          open={addModal}
          handleChange={handleInputChnage}
          handleCancel={handleCancelAddModal}
          data={formData && formData}
          handleSave={handleSaveAddModal}
          categories={categories && categories}
          banks={clientBanks && clientBanks}
        />
      )}
      {editModal && (
        <EditMultipleTransaction
          handleChange={handleChange}
          editModal={editModal}
          editModalData={editModalData}
          handleCancelEditModal={handleCancelEditModal}
          handleSaveEditModal={handleSaveEditModal}
          handleDeleteEditModal={handleDeleteEditModal}
          categories={categories && categories}
          clientBanks={clientBanks && clientBanks}
          data={editModalData && editModalData}
        />
      )}
      <Modal
        centered
        visible={isHistoryModalOpen}
        footer={null}
        closable={false}
        onCancel={false}
      >
        <h3 className="modaltitle">Transaction History</h3>
        <div style={{}}>
          <div className="">
            <div className="inputTitle">Original Values</div>
            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {transactionHistory && transactionHistory.length > 0 ? (
                <table id="clients">
                  <tr>
                    <th>Date of Change</th>
                    <th>Date</th>
                    <th>Item</th>
                    <th>Amount</th>
                    <th>Category</th>
                  </tr>
                  {transactionHistory &&
                    transactionHistory.map((data, index) => (
                      <tr key={index}>
                        <td>{moment(data.created_at).format("MM-DD-YYYY")}</td>
                        <td
                          style={{
                            color:
                              data.changedFields && data.changedFields.date
                                ? "#09A84D"
                                : "inherit",
                            fontWeight:
                              data.changedFields && data.changedFields.date
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {moment(data.date).format("MM/DD/YYYY")}
                        </td>
                        <td
                          style={{
                            color:
                              data.changedFields && data.changedFields.itemName
                                ? "#09A84D"
                                : "inherit",
                            fontWeight:
                              data.changedFields && data.changedFields.itemName
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {data.itemName ? data.itemName : "N/A"}
                        </td>
                        <td
                          style={{
                            color:
                              data.changedFields && data.changedFields.amount
                                ? "#09A84D"
                                : "inherit",
                            fontWeight:
                              data.changedFields && data.changedFields.amount
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {data.amount ? "$" + data.amount.toFixed(2) : "N/A"}
                        </td>
                        <td
                          style={{
                            color:
                              data.changedFields &&
                              data.changedFields.categoryFromPlaid
                                ? "#09A84D"
                                : "inherit",
                            fontWeight:
                              data.changedFields &&
                              data.changedFields.categoryFromPlaid
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {data.categoryFromPlaid
                            ? data.categoryFromPlaid
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                </table>
              ) : (
                <div
                  className="selectmain"
                  style={{ fontWeight: "bold", justifyContent: "center" }}
                >
                  {" "}
                  No History Found for this Account.
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button className="savebutton" onClick={handleHistoryCancel}>
            Close
          </button>
        </div>
      </Modal>
      {categoryModal && (
        <Modal
          visible={categoryModal}
          footer={null}
          onOk={handleCancelCategory}
          onCancel={handleCancelCategory}
          closable={false}
          centered
        >
          <h3 className="modaltitle">Add Category</h3>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Create under a Primary Category</h3>
            <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="Choose Primary Category"
              allowClear
              // treeDefaultExpandAll
              value={formData && formData.categoryName}
              onChange={(value, id) => {
                console.log("value", value);
                handleInputChnage("categoryName", value);
              }}
            >
              {categories &&
                categories.map((category) => (
                  <TreeNode
                    key={category.id}
                    value={category.categoryName}
                    title={category.categoryName}
                  >
                    {category.subCategories.map((subCategory, index) => (
                      <TreeNode
                        disabled
                        key={`${category.id}-${index}`}
                        value={subCategory.name}
                        title={subCategory.name}
                      />
                    ))}
                  </TreeNode>
                ))}
            </TreeSelect>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">New Category</h3>
            <input
              className="roleInput"
              placeholder="Category"
              name="subCategoryName"
              value={formData && formData.subCategoryName}
              id="categoryName"
              onChange={(e) => {
                e.preventDefault();
                handleInputChnage(e.target.name, e.target.value);
              }}
            />
          </div>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancelCategory();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              disabled={!formData || !formData.subCategoryName}
              onClick={() => {
                handleSaveCategory();
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      <NewLoader isLoading={loading} />
      {/* <Loader isLoading={loading} /> */}
    </div>
  );
};
